import visaLogo from "@assets/visa-logo.png";

interface PrimeseatLogoProps {
  className?: string;
}

const PrimeseatLogo = ({ className = "" }: PrimeseatLogoProps) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img
        src={visaLogo}
        alt="Visa"
        className="h-[0.9rem] w-auto object-contain mr-3"
      />
      <div className="flex items-center gap-1">
        <span
          className="font-montserrat font-extrabold text-primeseat-blue tracking-[0.25em] uppercase text-xs"
        >
          DINING
        </span>
        <div className="flex flex-col h-[0.75rem] w-[1.125rem] flex-shrink-0">
          <div className="h-1/3 bg-[#1434CB] w-full"></div>
          <div className="h-1/3 w-full"></div>
          <div className="h-1/3 bg-[#FCC015] w-full"></div>
        </div>
      </div>
    </div>
  );
};

export default PrimeseatLogo;
